<template lang="pug">
  div.ymap-section
    CircleLoader(:show="load" :size="loaderSize")
    div.ymap-content(ref="ymap" :class="{ hidden: load }")
    div.ymap-description(:class="{ hidden: load }")
      div.ymap-description__container
        p.ymap-description__container-title Офис АО “СТАТУС”
        br
        div.row
          img.column(src="/img/pin.svg")
          div.column {{ filial.address }}
        br
        div.row.filial-schedule
          img.column(src="/img/green_clock.svg")
          div.column Пн-Пт: {{ filial.office_wh }}
        div.row.filial-schedule
          img.column(src="/img/red_clock.svg")
          div.column {{ weekends }}: выходной
        p.filial-description Прием осуществляется по электронной очереди с выдачей талонов в следующем порядке: с понедельника по пятницу – {{ filial.office_wh }} часов без перерыва на обед.
</template>

<script>
import ymapInit from "@/plugins/ymap-init";
import { mapGetters } from "vuex";
import CircleLoader from "@/components/ui/core/CircleLoader";
import vacationsScheme from "@/forms/data/vacations";

export default {
  components: { CircleLoader },
  data() {
    return {
      map: null,
      load: false,
      loaderSize: {
        width: "90px",
        height: "90px"
      }
    };
  },
  computed: {
    ...mapGetters("form", ["form"]),
    filial() {
      return this.form && this.form.data.filial ? this.form.data.filial : false;
    },
    vacations() {
      return this.filial.office_vacations.map(item => item.toLowerCase());
    },
    weekends() {
      return this.filial
        ? Object.keys(vacationsScheme)
            .filter(item => !this.vacations.includes(item.toLowerCase()))
            .join(", ")
        : "";
    }
  },
  mounted() {
    this.load = true;
    ymapInit().then(() => {
      this.renderMap();
    });
  },
  methods: {
    renderMap() {
      window.ymaps.ready(() => {
        const coordinates = this.filial.coordinates.split(",");
        this.map = new window.ymaps.Map(
          this.$refs.ymap,
          {
            center: coordinates,
            zoom: 14,
            controls: []
          },
          {
            suppressMapOpenBlock: true
          }
        );

        // this.map.behaviors.disable([
        //   "scrollZoom",
        //   "drag",
        //   "rightMouseButtonMagnifier"
        // ]);

        const myGeoObject = new window.ymaps.Placemark(
          coordinates,
          {
            hintContent: this.filial.address,
            balloonContent: `${this.filial.format}<br><br>Время работы:<br>${this.filial.office_wh}<br><br>Время работы операционного зала:<br>${this.filial.shedule}<br><br>Выходные:<br>${this.weekends}`
          },
          {
            iconLayout: "default#image",
            iconImageHref: "/img/placemark.svg",
            iconImageSize: [28, 39]
            // iconImageOffset: [-5, -38]
          }
        );

        this.map.geoObjects.add(myGeoObject);

        this.load = false;
      });
    }
  }
};
</script>

<style lang="scss">
.filial-schedule {
  padding-bottom: 6px;
}
.filial-description {
  padding-top: 10px;
}
.ymap {
  &-section {
    position: relative;
    border-radius: 14px;
    overflow: hidden;

    .lds-ring {
      right: 50%;
      transform: translate(50%, -50%);
    }
  }

  &-content {
    width: 100%;
    height: 80vh;
    border-radius: 14px;
    overflow: hidden;
  }

  &-description {
    position: absolute;
    top: 30px;
    right: 30px;
    background-color: #fff;
    width: 280px;
    border-radius: 14px;

    &__container {
      padding: 20px;

      &-title {
        font-size: 16px;
        line-height: 19.5px;
        font-weight: 600;
        text-align: center;
      }
    }
  }
}

.row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  img {
    padding-right: 20px;
  }
}

.column {
  display: flex;
  flex-direction: column;
  flex-basis: 100%;
  flex: 1;
  flex-grow: 0;
  vertical-align: middle;
  &:nth-child(2) {
    flex: 2;
  }
}

ymaps canvas,
ymaps[class*="-ground-pane"] {
  -webkit-filter: grayscale(1);
  filter: grayscale(1);
}

@media screen and (max-width: 768px) {
  .ymap-description {
    display: none;
  }
}
</style>
